<template>
    <div class="dark:bg-white">
        <section id="about-hero-wrapper">
            <div class="bg-black relative overflow-hidden z-10">
                <BaseSvg
                    name="ShapeMask"
                    id="about-hero-mask"
                    class="absolute h-full z-30"
                    aria-hidden="true"
                />
                <div
                    id="about-hero-text"
                    class="wrap wrap-epic absolute left-1/2 opacity-0 -tracking-[1px] -translate-x-1/2 -translate-y-[50%] top-[27%] w-full z-20 at600:top-1/4"
                >
                    <h1
                        class="pl-5 tracking-wide text-lg text-red at768:leading-[0.95em] at768:mb-2 at768:text-[3.2366071429vw] at768:tracking-normal at1350:mb-8 at1680:text-[58px]"
                    >
                        About SECLOCK
                    </h1>
                    <h2
                        class="font-semibold leading-[0.95em] pl-5 text-2xl text-white at768:leading-[0.95em] at768:text-[4.7991071429vw] at1680:text-[86px]"
                    >
                        Born from a legacy of superior service —
                        <span class="at600:block"
                            >on a path of constant innovation.</span
                        >
                    </h2>
                </div>
                <video
                    src="https://marketing-assets.seclock.com/video/upload/q_auto,f_auto:video/web_bg_bw_noaudio"
                    class="max-w-none opacity-40 relative w-[150%] z-10 at600:max-w-full at600:w-full"
                    autoplay
                    disablepictureinpicture
                    loop
                    muted
                    playsinline
                />
            </div>
        </section>
        <section
            class="wrap wrap-epic at600:mt-12 at1024:-mt-8 at1024:relative at1024:z-10"
        >
            <div class="max-w-md at1200:max-w-[648px]">
                <h3
                    class="font-semibold leading-[0.89em] mb-4 mx-auto text-2xl -tracking-[1px] at768:leading-[0.89em] at768:text-3xl at1200:leading-[0.89em] at1200:text-5xl at1440:mb-10 at1440:leading-[0.89em] at1440:text-6xl dark:text-gray-800"
                >
                    We believe customer service is the key to success.
                </h3>
                <p
                    class="leading-[1.14] mx-auto text-gray text-lg -tracking-[0.01em] at1200:leading-[1.14] at1200:text-[28px]"
                >
                    As the leading wholesale-only distributor of electrical and
                    mechanical door hardware, we treat our customers as partners.
                    Our unrivaled in-stock inventory, expert customer support, and
                    just-in-time shipping continues to earn customer loyalty year
                    after year.
                </p>
            </div>
            <ul
                class="gap-4 grid items-start mt-16 text-gray at600:grid-cols-2 at768:grid-cols-3 at1024:mt-24 at1440:gap-8"
            >
                <li class="max-w-lg overflow-hidden rounded-xl shadow-extra-light">
                    <img
                        src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/branded-boxes"
                        height="274"
                        width="512"
                        sizes="512px"
                        loading="lazy"
                        alt=""
                    />
                    <div class="p-5 pb-8 at1024:p-8 at1440:px-10 at1440:pb-11">
                        <h3
                            class="font-semibold mb-2 text-black text-xl at1200:text-3xl"
                        >
                            Vast inventory
                        </h3>
                        <p
                            class="leading-[1.14] -tracking-[0.01em] at1024:leading-[1.14] at1024:text-lg at1200:leading-[1.1] at1200:text-[22px]"
                        >
                            The most premium products from the most premium
                            manufacturers, SECLOCK has the industry’s deepest and
                            widest inventory.
                        </p>
                    </div>
                </li>
                <li
                    class="max-w-lg overflow-hidden rounded-xl shadow-extra-light at768:mt-14 at1200:mt-28"
                >
                    <img
                        src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/service-rep-rounded-top"
                        height="306"
                        width="512"
                        sizes="512px"
                        loading="lazy"
                        alt=""
                    />
                    <div class="p-5 pb-8 at1024:p-8 at1440:px-10 at1440:pb-11">
                        <h3
                            class="font-semibold mb-2 text-black text-xl at1200:text-3xl"
                        >
                            Technical expertise
                        </h3>
                        <p
                            class="leading-[1.14] -tracking-[0.01em] at1024:leading-[1.14] at1024:text-lg at1200:leading-[1.1] at1200:text-[22px]"
                        >
                            Field-experienced and factory-trained, our technical
                            sales reps are unmatched and always available to
                            identify solutions for even the toughest jobs.
                        </p>
                    </div>
                </li>
                <li
                    class="max-w-lg overflow-hidden rounded-xl shadow-extra-light at768:mt-28 at1200:mt-56"
                >
                    <img
                        src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/shipping-rep-rounded-top"
                        height="306"
                        width="512"
                        sizes="512px"
                        loading="lazy"
                        alt=""
                    />
                    <div class="p-5 pb-8 at1024:p-8 at1440:px-10 at1440:pb-11">
                        <h3
                            class="font-semibold mb-2 text-black text-xl at1200:text-3xl"
                        >
                            Quick shipping
                        </h3>
                        <p
                            class="leading-[1.14] -tracking-[0.01em] at1024:leading-[1.14] at1024:text-lg at1200:leading-[1.1] at1200:text-[22px]"
                        >
                            With the most products on the shelf and just-in-time
                            delivery, you can say goodbye to unnecessary delays and
                            hello to getting the job done sooner.
                        </p>
                    </div>
                </li>
            </ul>
        </section>
        <section class="-mb-64 pt-12 px-4 at1024:pt-24 at1024:px-8 at1440:pt-40 dark:bg-white">
            <div class="wrap wrap-gigantic h-88 !px-0 relative at768:h-auto">
                <h3
                    class="absolute font-medium leading-none left-4 max-w-5xl pr-4 text-[32px] text-white top-4 at768:left-8 at768:text-4xl at768:top-8 at1024:left-16 at1024:text-5xl at1024:top-16 at1440:text-[80px]"
                >
                    Remembering our heritage —
                    <span class="block">never resting on it.</span>
                </h3>
                <div
                    id="timeline-main"
                    class="absolute font-medium max-w-4xl top-[74%] w-full at768:text-xl at768:top-[78%] at1024:leading-none at1024:text-2xl at1440:text-[35px] at1440:top-[80%] at1550:top-[82.2175732218%] dark:text-gray-800"
                >
                    <Splide
                        ref="timelineMain"
                        :options="{
                            arrows: false,
                            mediaQuery: 'min',
                            padding: { left: 16, right: 0 },
                            pagination: false,
                            rewind: true,
                            type: 'fade',
                            breakpoints: {
                                768: {
                                    padding: { left: 32, right: 0 },
                                },
                                1024: {
                                    padding: { left: 50, right: 0 },
                                },
                            },
                        }"
                    >
                        <SplideSlide
                            >Security Lock Distributors is founded in Westwood,
                            MA.</SplideSlide
                        >
                        <SplideSlide
                            >Security Lock Distributors opens Florida
                            branch.</SplideSlide
                        >
                        <SplideSlide
                            >Security Lock Distributors opens West Coast branch in
                            Las Vegas, NV.</SplideSlide
                        >
                        <SplideSlide
                            >Security Lock Distributors moves to larger space at 25
                            Dartmouth Street Westwood, MA to support increased
                            customer growth.</SplideSlide
                        >
                        <SplideSlide
                            >Security Lock Distributors opens first Midwest location
                            in Buffalo Grove, IL.</SplideSlide
                        >
                        <SplideSlide
                            >Security Lock Distributors moves to Lincolnshire, IL —
                            nearly doubling their Midwest distribution center
                            capacity.</SplideSlide
                        >
                        <SplideSlide
                            >Security Lock Distributors grows again, acquiring an
                            additional East Coast warehouse and updates brand to
                            SECLOCK.</SplideSlide
                        >
                        <SplideSlide
                            >SECLOCK continues to grow, increasing warehouse space
                            and stocking the most inventory in the
                            industry.</SplideSlide
                        >
                    </Splide>
                </div>
                <div
                    id="timeline-thumbs"
                    class="absolute font-medium text-2xl text-white top-[47%] w-full at768:top-[52%] at1024:text-3xl at1440:text-4xl at1440:top-[60%] at1550:top-[67.6778242678%]"
                >
                    <Splide
                        ref="timelineThumbs"
                        @splide:mounted="syncTimeline"
                        :options="{
                            arrows: false,
                            fixedWidth: 90,
                            focus: 'center',
                            isNavigation: true,
                            mediaQuery: 'min',
                            padding: { left: 16, right: 0 },
                            pagination: false,
                            rewind: true,
                            breakpoints: {
                                768: {
                                    fixedWidth: 140,
                                    padding: { left: 32, right: 0 },
                                },
                                1024: {
                                    fixedWidth: 206.5,
                                    padding: { left: 50, right: 0 },
                                },
                            },
                        }"
                    >
                        <SplideSlide>1982</SplideSlide>
                        <SplideSlide>1995</SplideSlide>
                        <SplideSlide>1997</SplideSlide>
                        <SplideSlide>2001</SplideSlide>
                        <SplideSlide>2008</SplideSlide>
                        <SplideSlide>2018</SplideSlide>
                        <SplideSlide>2020</SplideSlide>
                        <SplideSlide>2023</SplideSlide>
                    </Splide>
                </div>
                <img
                    src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/timeline-bg"
                    height="956"
                    width="1702"
                    sizes="1702px"
                    loading="lazy"
                    alt=""
                    class="h-full object-cover w-full at768:h-auto at768:w-auto"
                />
            </div>
        </section>
        <section class="bg-gray-100 pt-64 dark:text-gray-800">
            <div
                class="wrap wrap-epic pt-14 at1024:pt-24 at1440:pt-44"
            >
                <h3
                    class="font-medium leading-[0.89em] max-w-2xl mb-8 mx-auto text-center text-2xl -tracking-[1px] at768:mb-12 at768:text-4xl at1024:max-w-5xl at1024:mb-16 at1024:leading-[0.89em] at1024:text-4xl at1200:leading-[0.89em] at1200:mb-36 at1200:text-6xl"
                >
                    From high-tech to high-touch, we’re always innovating new ways
                    to help your business succeed.
                </h3>
                <ul
                    class="gap-4 grid at768:grid-cols-2 at1024:gap-7 at1440:grid-cols-4"
                >
                    <li
                        class="bg-white flex flex-col justify-between overflow-hidden rounded-[4px] at1024:h-[500px] at1440:h-[600px]"
                    >
                        <div class="p-4 at768:p-8 at1024:p-12">
                            <h3
                                class="font-semibold tracking-[-1px] mb-2 text-xl at768:text-2xl at1024:text-3xl at1200:text-4xl"
                            >
                                Blind-Label Shipping
                            </h3>
                            <p
                                class="text-gray at768:leading-[1.08] at768:text-lg at1024:text-[26px]"
                            >
                                Leverage our warehouse as your own — have packages
                                delivered with only your company’s branding.
                            </p>
                        </div>
                        <div
                            class="flex flex-col justify-between pl-4 at768:h-[275px] at768:pl-8 at1024:pl-12"
                        >
                            <button
                                @click.stop.prevent="showNewMessage"
                                class="flex font-semibold group items-center gap-2 mb-8 self-start text-blue uppercase at1024:mb-0 at1024:text-xl"
                            >
                                Talk to a rep<span class="sr-only"> about blind-label shipping</span>
                                <BaseSvg
                                    name="ArrowForward"
                                    aria-hidden="true"
                                    class="h-7 transition-transform group-hover:translate-x-1.5"
                                />
                            </button>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/about-blind-shipping-label"
                                class="self-end"
                                height="134"
                                width="249"
                                sizes="249px"
                                loading="lazy"
                                alt=""
                            />
                        </div>
                    </li>
                    <li
                        class="bg-white flex flex-col justify-between overflow-hidden rounded-[4px] at1024:h-[500px] at1440:h-[600px]"
                    >
                        <div class="p-4 at768:p-8 at1024:p-12">
                            <h3
                                class="font-semibold tracking-[-1px] mb-2 text-xl at768:text-2xl at1024:text-3xl at1200:text-4xl"
                            >
                                Quoting Department
                            </h3>
                            <p
                                class="text-gray at768:leading-[1.08] at768:text-lg at1024:text-[26px]"
                            >
                                Experts ready to spec out projects and help you win
                                more business.
                            </p>
                        </div>
                        <div
                            class="flex flex-col justify-between pl-4 at768:h-[275px] at768:pl-8 at1024:pl-12"
                        >
                            <button
                                @click.stop.prevent="showNewMessage"
                                class="flex font-semibold group items-center gap-2 mb-2 self-start text-blue uppercase at1024:mb-0 at1024:text-xl"
                            >
                                Talk to a rep<span class="sr-only"> about our quoting department</span>
                                <BaseSvg
                                    name="ArrowForward"
                                    aria-hidden="true"
                                    class="h-7 transition-transform group-hover:translate-x-1.5"
                                />
                            </button>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/about-quoting-department"
                                class="self-end"
                                height="234"
                                width="273"
                                sizes="273px"
                                loading="lazy"
                                alt=""
                            />
                        </div>
                    </li>
                    <li
                        class="bg-white flex flex-col justify-between overflow-hidden rounded-[4px] at1024:h-[500px] at1440:h-[600px]"
                    >
                        <div class="p-4 at768:p-8 at1024:p-12">
                            <h3
                                class="font-semibold tracking-[-1px] mb-2 text-xl at768:text-2xl at1024:text-3xl at1200:text-4xl"
                            >
                                SECLOCK Onsite
                            </h3>
                            <p
                                class="text-gray at768:leading-[1.08] at768:text-lg at1024:text-[26px]"
                            >
                                Email us a photo of your toughest projects —
                                wherever you are.
                            </p>
                        </div>
                        <div
                            class="flex flex-col justify-between pl-4 at768:h-[275px] at768:pl-8 at1024:pl-12"
                        >
                            <Link :href="route('web.contact')" class="flex font-semibold group items-center gap-2 mb-10 self-start text-blue uppercase at1024:mb-0 at1024:text-xl">
                                Learn more<span class="sr-only"> about SECLOCK Onsite</span>
                                <BaseSvg
                                    name="ArrowForward"
                                    aria-hidden="true"
                                    class="h-7 transition-transform group-hover:translate-x-1.5"
                                />
                            </Link>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/about-seclock-onsite"
                                class="self-end translate-x-1 translate-y-1"
                                height="204"
                                width="289"
                                sizes="289px"
                                loading="lazy"
                                alt=""
                            />
                        </div>
                    </li>
                    <li
                        class="bg-white flex flex-col justify-between overflow-hidden rounded-[4px] at1024:h-[500px] at1440:h-[600px]"
                    >
                        <div class="p-4 at768:p-8 at1024:p-12">
                            <h3
                                class="font-semibold tracking-[-1px] mb-2 text-xl at768:text-2xl at1024:text-3xl at1200:text-4xl"
                            >
                                EDI Integration
                            </h3>
                            <p
                                class="text-gray at768:leading-[1.08] at768:text-lg at1024:text-[26px]"
                            >
                                Seamless connection with daily document processing
                                to move your business along.
                            </p>
                        </div>
                        <div
                            class="flex flex-col justify-between pl-4 at768:h-[275px] at768:pl-8 at1024:pl-12"
                        >
                            <button
                                @click.stop.prevent="showNewMessage"
                                class="flex font-semibold group items-center gap-2 mb-8 self-start text-blue uppercase at1024:mb-0 at1024:text-xl"
                            >
                                Talk to a rep<span class="sr-only"> about EDI integration</span>
                                <BaseSvg
                                    name="ArrowForward"
                                    aria-hidden="true"
                                    class="h-7 transition-transform group-hover:translate-x-1.5"
                                />
                            </button>
                        </div>
                    </li>
                    <li
                        class="bg-white flex flex-col justify-between overflow-hidden rounded-[4px] at1024:col-span-2 at1024:h-[857px]"
                    >
                        <div class="max-w-[575px] p-4 at768:p-8 at1024:p-12">
                            <h3
                                class="font-semibold tracking-[-1px] mb-2 text-xl at768:text-2xl at1024:text-3xl at1200:text-4xl"
                            >
                                Parts Department
                            </h3>
                            <p
                                class="text-gray at768:leading-[1.08] at768:text-lg at1024:text-[32px]"
                            >
                                Experts ready and willing to solve, source, reconfigure, and ship you just what you need.
                            </p>
                        </div>
                        <div
                            class="flex flex-col justify-between pl-4 at768:pl-8 at1024:pl-12 at768:h-[300px] at960:h-[350px] at1024:h-[600px]"
                        >
                            <a
                                href="/parts"
                                class="flex font-semibold group items-center gap-2 mb-8 self-start text-blue uppercase at1024:mb-0 at1024:text-xl"
                            >
                                Learn more<span class="sr-only"> about our parts department</span>
                                <BaseSvg
                                    name="ArrowForward"
                                    aria-hidden="true"
                                    class="h-7 transition-transform group-hover:translate-x-1.5"
                                />
                            </a>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/about-parts-department"
                                class="self-end"
                                height="497"
                                width="770"
                                sizes="770px"
                                loading="lazy"
                                alt=""
                            />
                        </div>
                    </li>
                    <li
                        class="bg-black flex flex-col justify-between overflow-hidden rounded-[4px] at1024:col-span-2 text-white at1024:h-[857px]"
                    >
                        <div class="max-w-[650px] p-4 at768:p-8 at1024:p-12">
                            <h3
                                class="font-semibold tracking-[-1px] mb-2 text-xl at768:text-2xl at1024:text-3xl at1200:text-4xl"
                            >
                                Coming <span class="text-red">Soon</span>
                            </h3>
                            <p
                                class="at768:leading-[1.08] at768:text-lg at1024:text-[32px] text-gray-400"
                            >
                                An industry game changer - transforming the way door
                                hardware projects get done.
                            </p>
                        </div>
                        <div
                            class="flex flex-col justify-between at768:h-[300px] at960:h-[350px] at1024:h-[600px]"
                        >
                            <a
                                href="https://sld.typeform.com/to/ngXwBYG4"
                                class="flex font-semibold group items-center gap-2 mb-8 pl-4 self-start uppercase at768:pl-8 at1024:mb-0 at1024:pl-12 at1024:text-xl"
                                target="_blank"
                            >
                                Sign up for updates
                                <BaseSvg
                                    name="ArrowForward"
                                    aria-hidden="true"
                                    class="h-7 transition-transform group-hover:translate-x-1.5"
                                />
                            </a>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto/beta_preview_FPO"
                                height="950"
                                width="2200"
                                sizes="2200px"
                                loading="lazy"
                                alt="Preview teaser"
                                class="px-8"
                            />
                        </div>
                    </li>
                </ul>
            </div>
        </section>
        <section
            class="bg-gray-100 overflow-hidden pt-88 relative at768:pt-96 at1024:pt-104 at1200:pt-[500px] at1440:pt-[550px] dark:text-gray-800"
        >
            <div
                class="absolute aspect-square bg-black/10 left-1/2 rounded-full top-48 -translate-x-1/2 at1024:top-64"
                style="filter: blur(152px); width: 370.87053571%"
            ></div>
            <div
                class="absolute aspect-square bg-white left-1/2 rounded-full top-48 -translate-x-1/2 at1024:top-64"
                style="width: 370.87053571%"
            >
                <div
                    class="absolute left-1/2 max-w-[200px] rounded-full shadow-red-icon top-0 -translate-x-1/2 -translate-y-1/2 w-1/4"
                >
                    <span
                        class="absolute bg-white h-4/5 left-1/2 rounded-full top-1/2 -translate-x-1/2 -translate-y-1/2 w-4/5"
                    ></span>
                    <BaseSvg name="seclock-icon" class="relative w-full" />
                </div>
            </div>
            <div class="bg-white pb-32 relative at1024:pb-64">
                <div
                    class="wrap wrap-large flex flex-col gap-6 items-center mb-24 text-center at1024:gap-10 at1024:mb-44 at1024:text-[22px]"
                >
                    <h3
                        class="font-semibold leading-[0.89em] text-2xl -tracking-[1px] at768:text-3xl at1024:max-w-5xl at1024:leading-[0.89em] at1024:pb-6 at1024:text-4xl at1200:leading-[0.89em] at1200:text-6xl"
                    >
                        At SECLOCK,
                        <span class="block text-gray"
                            >Your Business is Personal</span
                        >
                    </h3>
                    <p class="text-gray">
                        Did you know that each SECLOCK customer has a dedicated
                        account representative? Our experts are here to personalize
                        your service, learn your needs, and do everything we can to
                        make sure that your business is successful.
                    </p>
                    <p class="text-gray">
                        Fill out the form below to request a meeting with your
                        account representative.
                    </p>
                    <AccountRepresentativeMeetingForm />
                </div>
                <div
                    class="wrap wrap-huge flex flex-col gap-5 at768:flex-row at1024:gap-[30px]"
                >
                    <div
                        class="bg-gray-800 flex flex-col items-start justify-between p-8 rounded-md text-white w-full at1024:p-16 at1024:pt-14"
                    >
                        <div>
                            <h4
                                class="font-semibold leading-none text-2xl at768:text-4xl at1200:text-[64px]"
                            >
                                The key to a fulfilling career
                            </h4>
                        </div>
                        <a
                            href="/careers"
                            class="btn-white-on-red mt-8 at768:mt-12"
                        >
                            Find your career
                            <BaseSvg name="arrow-forward" class="ml-3" aria-hidden="true"/>
                        </a>
                    </div>
                    <div
                        class="bg-gray flex flex-col items-start justify-between p-8 rounded-md text-white w-full at1024:p-16 at1024:pt-14"
                    >
                        <div>
                            <h4
                                class="font-semibold leading-none text-2xl at768:text-4xl at1200:text-[64px]"
                            >
                                Contact Us
                            </h4>
                            <p
                                class="leading-none mt-4 text-lg at768:text-xl at1200:text-[32px]"
                            >
                                For any and all inquiries, we’re here.
                            </p>
                        </div>
                        <a
                            href="/contact"
                            class="btn-white-on-red mt-8 at768:mt-12"
                        >
                            Reach out
                            <BaseSvg name="arrow-forward" class="ml-3" aria-hidden="true" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <Meta
        title="Commercial Door Locks | Door Hardware Distributor"
        description="Commercial Door Locks and Door Hardware Distributor SECLOCK is the trusted leader in wholesale door hardware and security products. For inquiries, call 800.847.5625."
    />
</template>

<style>
#timeline-thumbs .splide__track {
    padding-bottom: 57px;
}
#timeline-thumbs .splide__slide::before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='9' fill='none' viewBox='0 0 24 9'%3E%3Cg clip-path='url(%23a)'%3E%3Ccircle cx='4.5' cy='4.5' r='4.5' fill='%23fe1940'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h24v9H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
    content: "";
    display: block;
    height: 9px;
    left: 0;
    position: absolute;
    top: calc(100% + 18px);
    width: 100%;
}
#timeline-thumbs .splide__slide::after {
    background-color: #fe1940;
    border-radius: 50%;
    content: "";
    display: block;
    height: 18px;
    position: absolute;
    top: calc(100% + 13px);
    transition-duration: 150ms, 150ms, 150ms;
    transition-property: height, top, width;
    width: 18px;
}
#timeline-thumbs .splide__slide.is-active::after {
    height: 33px;
    top: calc(100% + 6px);
    width: 33px;
}
#timeline-thumbs .splide__slide:last-child::before {
    mask-image: linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.10));
}
@media screen and (min-width: 768px) {
    #timeline-thumbs .splide__slide::before {
        top: calc(100% + 31.5px);
    }
    #timeline-thumbs .splide__slide::after {
        height: 18px;
        top: calc(100% + 27px);
        width: 18px;
    }
    #timeline-thumbs .splide__slide.is-active::after {
        height: 42px;
        top: calc(100% + 15px);
        width: 42px;
    }
}
</style>

<script setup>
import { SplideSlide, Splide } from "@splidejs/vue-splide";
import {onBeforeUnmount, onMounted, ref} from "vue";
import { BaseSvg, Meta, AccountRepresentativeMeetingForm } from "@/Components";
import {useChat, useProductSearchDialog} from "@/Composables";
const { toggleProductSearchDialog } = useProductSearchDialog();
import { gsap } from "gsap";
import  ScrollTrigger  from "gsap/ScrollTrigger";
import {Link} from "@inertiajs/vue3";

onMounted(() => {
    let headerHeight = document.querySelector("header").offsetHeight;

    if(import.meta.env.SSR) return;
    const tl = gsap.timeline();
    tl.to("#about-hero-mask", {
        scale: 3.5,
        rotation: -3,
        x: "35%",
        y: "-15.75%",
    }).to("#about-hero-text", { opacity: 1 });

    ScrollTrigger.create({
        animation: tl,
        trigger: "#about-hero-wrapper",
        pin: true,
        start: () => "top " + headerHeight,
        // end: () => "bottom " + headerHeight,
        scrub: 1,
        // markers: true, // Debug markers
    });
});


onBeforeUnmount(()=>{
    if(import.meta.env.SSR) return;
    ScrollTrigger.getAll().forEach((trigger) => {
        trigger.kill();
    });
});

const timelineMain = ref();
const timelineThumbs = ref();

const { showNewMessage } = useChat();

function syncTimeline() {
    timelineMain.value.sync(timelineThumbs.value.splide);
}
</script>
